import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

function detectLang() {
  const saved = localStorage.getItem("lang");
  if (saved === "da" || saved === "en") return saved;
  const nav = (navigator.language || navigator.userLanguage || "da").toLowerCase();
  if (nav.startsWith("en")) return "en";
  return "da"; // default to Danish
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(detectLang);

  useEffect(() => {
    localStorage.setItem("lang", lang);
    // Danish-primary site: keep the document language "da" for SEO regardless of the
    // UI toggle / browser locale (UI text still switches via translations).
    document.documentElement.lang = "da";
  }, [lang]);

  const t = translations[lang];
  const toggle = () => setLang((l) => (l === "da" ? "en" : "da"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
